import React from 'react';

import { confirmAlert } from 'react-confirm-alert';
import { getAbility } from '../../../reducers/sessionReducer';
import { store } from '../../../store';
import dateUtils from '../../../utils/dateUtils';
import ConfTableBaseCell from '../../general/conf-table/ConfTableBaseCell';
import notificationActions from '../../general/notification/NotificationsManager/actions';
import cacheActions from '../../../actions/cacheActions';
import usefulLinkActions from '../../../actions/usefulLinkActions';

const usefulLinkTableColumns = [
  {
    name: 'name',
    title: 'Nome da Plataforma',
    editable: getAbility(store.getState()).can('update', 'UsefulLink'),
    width: 200,
  },
  {
    name: 'url',
    title: 'URL',
    type: 'url',
    editable: getAbility(store.getState()).can('update', 'UsefulLink'),
    width: 200,
  },
  {
    name: 'login',
    title: 'Login',
    editable: getAbility(store.getState()).can('update', 'UsefulLink'),
    width: 200,
  },
  {
    name: 'password',
    title: 'Senha',
    editable: getAbility(store.getState()).can('update', 'UsefulLink'),
    width: 200,
    visible: false,
  },
  {
    name: 'description',
    title: 'Descrição',
    editable: getAbility(store.getState()).can('update', 'UsefulLink'),
    width: 500,
  },
  {
    name: 'theme',
    title: 'Tema',
    editable: getAbility(store.getState()).can('update', 'UsefulLink'),
    width: 500,
  },
];

const usefulLinkSelectionOperations = [
  {
    label: 'Apagar itens',
    action: (selectedUsefulLinks) => {
      const params = { useful_link_ids: selectedUsefulLinks.filter(item => item != null).map(item => item.id) };

      confirmAlert({
        title: 'Confirmação de exclusão',
        message: 'Deseja mesmo apagar os registros?',
        buttons: [
          {
            label: 'Sim',
            onClick: () => {
              store
                .dispatch(usefulLinkActions.destroyAll(params))
                .then((response) => {
                  store.dispatch(notificationActions.showNotification('Apagado com sucesso', 'success'));
                  store.dispatch(cacheActions.cleanCache());
                  store.dispatch(usefulLinkActions.fetchAll());
                })
                .catch((apiResponse) => {
                  const message = apiResponse.data.errors[0].detail;
                  const color = 'danger';
                  store.dispatch(notificationActions.showNotification(message, color));
                  store.dispatch(cacheActions.cleanCache());
                  store.dispatch(usefulLinkActions.fetchAll());
                });
            },
          },
          {
            label: 'Não',
            onClick: () => {},
          },
        ],
      });
    },
    renderCondition: selectedUsefulLinks => selectedUsefulLinks.length > 1,
  },
];

const usefulLinkTableLeftFixedColumns = ['name'];

const usefulLinkTableDataSortingByColumns = [{ columnName: 'name', direction: 'asc' }];

const UsefulLinkTableCellComponent = (props) => {
  const { done } = props.row;
  let { contactDate } = props.row;
  const style = { ...props.style };

  contactDate = dateUtils.convertStringToDate(contactDate);
  const today = new Date();
  const timeDiff = today.getTime() - contactDate.getTime();
  const diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

  if (done) {
    style.backgroundColor = '#ccebff';
  } else if (diffDays > 0) {
    style.backgroundColor = '#ffcccc';
  } else if (diffDays === 0) {
    style.backgroundColor = '#adebad';
  } else if (diffDays > -8) {
    style.backgroundColor = '#d6f5d6';
  }

  return <ConfTableBaseCell {...props} style={style} />;
};

export {
  UsefulLinkTableCellComponent, usefulLinkTableDataSortingByColumns, usefulLinkTableLeftFixedColumns, usefulLinkSelectionOperations,
};
export default usefulLinkTableColumns;
